import React, { useState } from 'react'
import { Button, Dialog, DialogContent, DialogTitle, IconButton, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { deleteGroup, deleteProfile } from '@auteco/services/snopServices'
import { AiFillEdit } from 'react-icons/ai'
import DeleteIcon from '@material-ui/icons/Delete'
import { Alert } from '@auteco/components/snopComponents/Alert'
import { initialAlert } from '@auteco/constants'
import { DialogEdit } from '../DialogEdit'
import useStyles from './styles'

const initialDialog = {
    open: false,
    onClose: () => { }
}

const DialogDelete = ({ options, type, functionSuccess, open, onClose }) => {
    const [selectedItem, setSelectedItem] = useState()
    const [alertInfo, setAlertInfo] = useState(initialAlert)
    const [dialogInfo, setDialogInfo] = useState(initialDialog)


    const classes = useStyles()

    const handleClose = () => {
        onClose()
        setSelectedItem()
    }

    const onCloseAlert = () => {
        setAlertInfo(initialAlert)
    }

    const handleSuccess = () => {
        functionSuccess()
        setAlertInfo(initialAlert)
        setSelectedItem()
    }

    const handleFail = () => {
        setAlertInfo({ title: 'Error', content: `No se pudo eliminar este ${type}`, textBtn1: 'Cerrar', textBtn2: '', open: true, onClose: onCloseAlert, funcBtn: onCloseAlert })
    }


    const onDeleteMaterial = async () => {
        if (type === 'grupo') {
            const { success } = await deleteGroup({ id: selectedItem.id })
            if (success) {
                handleSuccess()
            } else {
                handleFail()
            }
        } else {
            const { success } = await deleteProfile({ id: selectedItem.id })
            if (success) {
                handleSuccess()
            } else {
                handleFail()
            }
        }
    }

    const onEditItem = () => {
        setDialogInfo({ open: true, onClose: () => setDialogInfo(initialDialog) })
    }

    const onDeleteItem = () => {
        setAlertInfo({ title: '¡Espera!', content: `Estás a punto de eliminar este ${type}, ¿deseas continuar?`, textBtn1: 'Cerrar', textBtn2: 'Continuar', open: true, onClose: onCloseAlert, funcBtn: () => onDeleteMaterial() })
    }
    return (
        <>
            <Alert
                title={alertInfo.title}
                content={alertInfo.content}
                textBtn1={alertInfo.textBtn1}
                textBtn2={alertInfo.textBtn2}
                funcBtn={alertInfo.funcBtn}
                open={alertInfo.open}
                onClose={onCloseAlert}
            />
            <DialogEdit type={type} item={options.find(option => option.id === selectedItem?.id)} functionSuccess={functionSuccess} open={dialogInfo.open} onClose={dialogInfo.onClose} />
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Editar o eliminar {type}</DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <Autocomplete
                        options={options}
                        value={options.find(option => option.id === selectedItem?.id) || null}
                        className={classes.options}
                        getOptionLabel={(option) => option.nombre}
                        onChange={(e, newValue) => setSelectedItem(newValue)}
                        renderInput={(params) => <TextField {...params} label={type} variant='outlined' style={{ textTransform: 'capitalize' }} />}
                    />
                    {selectedItem &&
                        <>
                            <IconButton onClick={onEditItem}>
                                <AiFillEdit />
                            </IconButton>
                            <IconButton onClick={onDeleteItem}>
                                <DeleteIcon />
                            </IconButton>
                        </>
                    }
                </DialogContent>
                <div className={classes.btnsContainer}>
                    <Button variant='contained' className={classes.closeBtn} onClick={handleClose}>Volver</Button>
                </div>
            </Dialog>
        </>
    )
}

export { DialogDelete }